import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useState,
} from "react";
import {
  Badge,
  Col,
  Offcanvas,
  OffcanvasBody,
  OffcanvasHeader,
  Row,
  Collapse,
} from "reactstrap";
import KOTService from "../../../../services/OrderingServices/KOTService";
import KotBill from "../component/KotBill";

const KOTList = forwardRef(
  ({ isOpen, toggle, setSelectedTable, setKotList, kotList }, ref) => {
    const [selectedKot, setSelectedKot] = useState(null);

    const fetchKot = async () => {
      try {
        const response = await KOTService.getList();
        // console.log("🚀 ~ fetchKot ~ response:", response);
        setKotList(response);
      } catch (error) {
        console.log(error);
      }
    };
    // Expose refresh method to parent via ref
    useImperativeHandle(ref, () => ({
      refreshKot: fetchKot,
    }));

   

    const [isDetailOpen, setIsDetailOpen] = useState(false);
    const toggleDetail = () => {
      setIsDetailOpen(!isDetailOpen);
    };

    const [openTableIds, setOpenTableIds] = useState({});

    const toggleCollapse = (tableId) => {
      setOpenTableIds((prev) => ({
        ...prev,
        [tableId]: !prev[tableId],
      }));
    };

    const handleTableSelect = (item) => {
      setSelectedTable({ id: item?.tableId, tableName: item?.tableName });
      toggle();
    };
    return (
      <Offcanvas
        isOpen={isOpen}
        toggle={toggle}
        direction="end"
        backdropClassName="bg-dark bg-opacity-50"
        className="shadow-lg animate__animated animate__slideInRight bg-white rounded-start"
        id="offcanvasRight"
      >
        {/* Mobile Header */}
        <OffcanvasHeader className="d-block d-sm-none">
          <div className="d-flex justify-content-between align-items-center w-100 rounded-top">
            <button className="btn btn-sm btn-light" onClick={toggle}>
              <i class="bx bx-chevron-left"></i>
            </button>
            <div className="d-flex align-items-center gap-2 w-100 justify-content-center">
              <i class="ri-file-list-3-line fs-4"></i>
              <h5 className="mb-0">KOT List</h5>
            </div>
          </div>
        </OffcanvasHeader>

        {/* Desktop Close Button */}
        <div
          className="position-absolute d-none d-sm-block"
          style={{ left: "-40px", top: "10px" }}
        >
          <button className="btn btn-sm btn-light" onClick={toggle}>
            <i className="ri-close-line"></i>
          </button>
        </div>

        {/* Desktop Header */}
        <div className="d-none d-sm-flex align-items-center gap-2 p-2 shadow-sm bg-light">
          <i class="ri-file-list-3-line fs-4"></i>
          <h5 className="mb-0">KOT List</h5>
        </div>

        <OffcanvasBody>
          <Row className="h-auto p-lg-3 p-2">
            {kotList?.map((table) => {
              const isOpen = openTableIds[table.tableId];
              const kotLogs = table.orderPrintingLogs || [];
              const firstLog = kotLogs[0];
              const remainingLogs = kotLogs.slice(1);

              return (
                <Col
                  lg={3}
                  md={4}
                  sm={6}
                  xs={12}
                  key={table.tableId}
                  className="mb-3"
                >
                  <div className="border rounded-4 shadow-sm d-flex flex-column bg-white  overflow-hidden">
                    {/* Table Header */}
                    <div className="bg-light px-3 py-2 d-flex justify-content-between align-items-start border-bottom flex-wrap gap-2">
                      <div
                        className="text-truncate cursor-pointer"
                        style={{ maxWidth: "70%" }}
                        onClick={() => handleTableSelect(table)}
                      >
                        <h6 className="mb-1 fs-6 fw-semibold text-primary text-truncate">
                          {table.tableName}
                        </h6>
                        <small className="text-muted">
                          {table.orderItemsCount} item
                          {table.orderItemsCount > 1 ? "s" : ""} • Rs.{" "}
                          {table.orderTotalAmount}
                        </small>
                      </div>
                      <Badge
                        color={
                          table.orderPrintingLogs.length > 0
                            ? "warning"
                            : "secondary"
                        }
                        className="text-nowrap mt-1"
                      >
                        {table.orderPrintingLogs.length > 0
                          ? "KOT Pending"
                          : "No KOT"}
                      </Badge>
                    </div>

                    {/* First KOT Entry */}
                    {firstLog ? (
                      <div
                        className="px-3 py-2 border-top kot-entry hover-bg-light"
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          setSelectedKot({
                            ...firstLog,
                            tableName: table.tableName,
                          });
                          toggleDetail();
                        }}
                      >
                        <div className="d-flex justify-content-between align-items-center flex-wrap gap-2">
                          <div className="text-truncate" style={{ flex: 1 }}>
                            <div className="d-flex justify-content-between">
                              <strong className="d-block text-body">
                                KOT #{firstLog.kotNumber}
                              </strong>
                              <Badge
                                color={
                                  firstLog.isPrinted ? "success" : "danger"
                                }
                                pill
                                className="text-nowrap mt-1"
                              >
                                <small>
                                  {firstLog.isPrinted
                                    ? "Printed"
                                    : "Not Printed"}
                                </small>
                              </Badge>
                            </div>
                            <small>Order Status: {firstLog?.printType}</small>

                            <small className="text-muted d-block">
                              By: {firstLog.orderBy}
                            </small>
                          </div>
                        </div>
                      </div>
                    ) : (
                      <div className="p-5 border-top kot-entry hover-bg-light">
                        {table.orderPrintingLogs.length > 0
                          ? "KOT Pending"
                          : "No KOT Available"}
                      </div>
                    )}

                    {/* Collapsible KOTs */}
                    {remainingLogs.length > 0 && (
                      <>
                        <Collapse isOpen={isOpen}>
                          {remainingLogs.map((log, index) => (
                            <div
                              key={index}
                              className="px-3 py-2 border-top kot-entry hover-bg-light"
                              style={{ cursor: "pointer" }}
                              onClick={() => {
                                setSelectedKot({
                                  ...log,
                                  tableName: table.tableName,
                                });
                                toggleDetail();
                              }}
                            >
                              <div className="d-flex justify-content-between align-items-center flex-wrap gap-2">
                                <div
                                  className="text-truncate"
                                  style={{ flex: 1 }}
                                >
                                  <div className="d-flex justify-content-between">
                                    <strong className="d-block text-body">
                                      KOT #{log.kotNumber}
                                    </strong>
                                    <Badge
                                      color={
                                        log.isPrinted ? "success" : "danger"
                                      }
                                      pill
                                      className="text-nowrap mt-1"
                                    >
                                      <small>
                                        {log.isPrinted
                                          ? "Printed"
                                          : "Not Printed"}
                                      </small>
                                    </Badge>
                                  </div>
                                  <small>Order Status: {log?.printType}</small>
                                  <small className="text-muted d-block">
                                    By: {log.orderBy}
                                  </small>
                                </div>
                              </div>
                            </div>
                          ))}
                        </Collapse>

                        {/* Collapse Toggle Button */}
                        <div className="text-center border-top py-2">
                          <button
                            type="button"
                            className="btn btn-link btn-sm text-decoration-none"
                            onClick={() => toggleCollapse(table.tableId)}
                          >
                            {isOpen
                              ? "View Less"
                              : `View ${remainingLogs.length} More`}
                          </button>
                        </div>
                      </>
                    )}
                  </div>
                </Col>
              );
            })}
          </Row>
        </OffcanvasBody>

        <KotBill
          isOpen={isDetailOpen}
          toggle={toggleDetail}
          kotData={selectedKot}
        />
      </Offcanvas>
    );
  }
);

export default KOTList;
